import axios from 'axios';
import { API_BASE_URL } from '../utils/constants';
import { getToken, logout } from './auth';
import { toast } from 'react-hot-toast';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // Log request for debugging
    console.log('API Request:', {
      method: config.method,
      url: config.url,
      data: config.data,
      headers: config.headers
    });
    
    return config;
  },
  (error) => {
    console.error('Request Error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => {
    console.log('API Response:', {
      status: response.status,
      data: response.data
    });
    return response;
  },
  (error) => {
    if (error.response) {
      // The request was made and the server responded with a status code
      console.error('Response Error:', {
        data: error.response.data,
        status: error.response.status,
        headers: error.response.headers
      });
      
      // Show detailed error message
      if (error.response.data && error.response.data.detail) {
        let errorMessage = error.response.data.detail;
        
        // Handle validation errors
        if (typeof errorMessage === 'object') {
          errorMessage = JSON.stringify(errorMessage);
        }
        
        toast.error(errorMessage);
      } else {
        toast.error(`Error ${error.response.status}: ${error.response.statusText}`);
      }
      
      // Handle 401 Unauthorized
      if (error.response.status === 401) {
        logout();
        window.location.href = '/login';
      }
    } else if (error.request) {
      // The request was made but no response was received
      console.error('No response received:', error.request);
      toast.error('No response from server. Please check if backend is running.');
    } else {
      // Something happened in setting up the request that triggered an Error
      console.error('Request setup error:', error.message);
      toast.error('Error setting up request: ' + error.message);
    }
    
    return Promise.reject(error);
  }
);

export default api;